import React from 'react';

const FilterIcon = ({ width }) => {
  return (
    <svg width="19" height="25" viewBox="0 0 19 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.99908 14.7828V0.444793C3.99908 0.196232 3.80285 0 3.55429 0H2.53388C2.28532 0 2.08909 0.196232 2.08909 0.444793V14.7828C1.08176 15.1753 0.362244 16.1434 0.362244 17.2815C0.362244 18.4197 1.08176 19.3877 2.076 19.7802V24.5552C2.076 24.8037 2.27224 25 2.5208 25H3.54121C3.78977 25 3.986 24.8037 3.986 24.5552V19.7802C4.99332 19.4008 5.69976 18.4197 5.69976 17.2815C5.71284 16.1434 4.99332 15.1753 3.99908 14.7828Z"
        fill="#CFD8DC"
      />
      <path
        d="M10.4616 5.07587V0.444793C10.4616 0.196232 10.2654 0 10.0169 0H8.99645C8.74788 0 8.55165 0.196232 8.55165 0.444793V5.07587C7.54433 5.45525 6.83789 6.43642 6.83789 7.57456C6.83789 8.71271 7.55741 9.68079 8.55165 10.0733V24.5552C8.55165 24.8037 8.74788 25 8.99645 25H10.0169C10.2654 25 10.4616 24.8037 10.4616 24.5552V10.0733C11.469 9.69387 12.1754 8.71271 12.1754 7.57456C12.1754 6.43642 11.469 5.46834 10.4616 5.07587Z"
        fill="#CFD8DC"
      />
      <path
        d="M16.924 11.6562V0.444793C16.924 0.196232 16.7278 0 16.4793 0H15.4588C15.2103 0 15.0141 0.196232 15.0141 0.444793V11.6431C14.0067 12.0225 13.3003 13.0037 13.3003 14.1418C13.3003 15.2799 14.0198 16.248 15.0141 16.6405V24.5552C15.0141 24.8037 15.2103 25 15.4588 25H16.4793C16.7278 25 16.924 24.8037 16.924 24.5552V16.6405C17.9314 16.2611 18.6378 15.2799 18.6378 14.1418C18.6378 13.0037 17.9314 12.0356 16.924 11.6562Z"
        fill="#CFD8DC"
      />
    </svg>
  );
};

export default FilterIcon;
